// extracted by mini-css-extract-plugin
export default {"tabs":"tabs-for-public-area-mobile-module--tabs--b8c5a","menuContainer":"tabs-for-public-area-mobile-module--menuContainer--e04d3"};